import { EducatorsReliefListingsApplication } from "@/types/serializers"
import { useProps } from "@/lib/page-rendering"

export type NewProps = {
  educator_name: string
  relief_listing_title: string
  educators_relief_listing_id: string
  listing_profile_options: Array<SelectOption<string> & { disabled: boolean }>
}

export const useNewProps = () => useProps<NewProps>()

export type ShowProps = {
  educator_name: string
  relief_listing_title: string
}

export const useShowProps = () => useProps<ShowProps>()

export type EditProps = {
  application: EducatorsReliefListingsApplication
}
export const useEditProps = () => useProps<EditProps>()
